'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NODE_ENV = exports.NODE_ENV = typeof process !== 'undefined' ? process.env.NODE_ENV : 'production';


//////////////////
// WEBPACK FOOTER
// ./~/redux-persist/lib/env.js
// module id = 79
// module chunks = 0